export default __webpack_public_path__ + "static/media/groupTermInsurance.a3df20cf.svg";